import { render, staticRenderFns } from "./edit-PendingReview.vue?vue&type=template&id=656b037a&scoped=true&"
import script from "./edit-PendingReview.vue?vue&type=script&lang=js&"
export * from "./edit-PendingReview.vue?vue&type=script&lang=js&"
import style0 from "./edit-PendingReview.vue?vue&type=style&index=0&id=656b037a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656b037a",
  null
  
)

export default component.exports